import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InterviewConsentFetchFailedAction = {
	type: 'INTERVIEW_CONSENT_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InterviewConsentFetchFailedAction => ({
	type: 'INTERVIEW_CONSENT_FETCH_FAILED',
	payload,
});
